import React from "react";
import './krishnadonate.css';

function KrishnaDonateTemple() {
    return (  
        <div>           
            <section id="content-page-715">
                <div className="cs-container">
                    <div className="cs-content">
                        <h1 className="cs-title">Support Krishna Temple</h1>
                        <h2>Donate using Zelle</h2>
                        <p>
                        You can send money with Zelle using your mobile to <br />
                            Phone Number: <h3>262-955-3216 <br />RADHA KRISHNA MISSION INC</h3>
                        </p>
                        <h2>Donate using PayPal</h2>
                                <p class="mb-4">Feel like contributing to our temple by donating? Click the donate button and complete it by entering the amount.! </p>
                                <form id="signUpForm" action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
                                    <input type="hidden" name="cmd" value="_s-xclick"></input>
                                    <input type="hidden" name="hosted_button_id" value="3QVM8X39Z3M4L"></input>
                                    <input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_donateCC_LG.gif" border="0" name="submit" alt="PayPal - The safer, easier way to pay online!"></input>
                                    <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1"></img>
                                </form>
                        <h2>It is Your Temple</h2>

                        <p align="justify">All donations made to Hare Krishna Temple of Milwaukee, WI are tax deductible. To continue serving the community, we kindly request your generous donations. Any size of donation is welcome and will be highly appreciated. We assure that all donated funds will be utilized strictly for the temple and community work. Please remember that donation made to Hare Krishna Mission Temple Milwaukee is tax deductible. Once the donation is received we will avail you necessary (official) documents for the deduction of taxes of your obligation.</p   >
                        <p align="justify">Also, when you receive confirmation from the temple for your donation, please check the address label and inform the temple if there are any typos.</p>
                        <p align="justify">Donation amounts are designed to suit all levels of giving. Contributing to our temple leave a permanent legacy for the future generations.</p>
                        <p align="justify">Please visit the Temple website for up-to-date information about temple activities, volunteer opportunities, and to make your financial commitment.</p>
                        <p align="justify">Please provide generous support for the Hare Krishna Mission Inc. Milwaukee, WI.</p>
                        <h5>Remember it is your Temple!<br />< br />Hari Bol !!!</h5>

                    </div>
                    <div className="cs-image-group">
                        <picture className="cs-picture">
                            <source media="(max-width: 600px)" srcSet="/images/header.png"></source>
                            <source media="(min-width: 601px)" srcSet="/images/header.png"></source>
                            <img loading="lazy" decoding="async" src="/images/header.png" alt="Donate to temple" width="570" height="680"></img>
                        </picture>
                    </div>
                </div>
                <picture className="cs-background">
                    <img src="https://csimg.nyc3.cdn.digitaloceanspaces.com/Images%2FGraphics%2Flarge-waves.svg" alt="waves" decoding="async" aria-hidden="true" width="625" height="952"></img>
                </picture>
            </section>  
        </div>                                
    );
}
export default KrishnaDonateTemple;